import { BarcodeFoodDataType } from "models/BarcodeFoodData";
import { BranchType } from "models/Branch";
import { HubType } from "models/Hub";
import { VendorType } from "models/Vendor";
import api from "Services/API";
import { ListResponseType } from "Services/Share.props";
import { FoodType } from "models/Food";
import { BranchParams, Params } from "./GlobalService.props";

export const getVendors = (params?: Params) => {
    return api.get<ListResponseType<VendorType>>(
        "/admin/vendor?page_size=1000",
        {
            params,
        }
    );
};

export const getHubs = (params?: Params) => {
    return api.get<ListResponseType<HubType>>("/admin/hub?page_size=1000", {
        params,
    });
};

export const getBranches = (params?: BranchParams) => {
    return api.get<ListResponseType<BranchType>>("/admin/branch", {
        params,
    });
};

export const getFoods = (branch_id: number) => {
    return api.get<Array<FoodType>>(`/admin/waste/new/${branch_id}`);
};

export const getBarcodeFoodSearch = (barcode: string) => {
    return api.get<BarcodeFoodDataType>(
        `/admin/barcode/food-search/${barcode}`
    );
};
